module.exports = __webpack_public_path__ + "r.no2.fff748e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/r.no2.jpg
// module id = nBJN
// module chunks = 0